import { browserHistory as history } from 'react-router';
import store from '../JavaScript/store';
import React, { Component } from 'react';
import Avatar from 'react-avatar';
import moment from 'moment';
import 'moment-duration-format';
import download from 'downloadjs';
import { headers, parseJSON } from './apiUtils';
import { ZacousticPermission, SurveyType, OrderByDirection, ClientSettingKeys, CalibrationStatus } from './generated';
import fetchFsa from './Utils/fetchFsa';
import { clientIdNumber, colors, dateTimeFormat } from './constants';
import FilterArrow from './icons/v3/FilterArrow';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
//import { func } from 'prop-types';
import { announcePageLoaded } from '@zacousticrepo/grommet-v1-custom/utils/Announcer';

const DEFAULT_TITLE = 'Zacoustic';

export function generateHierarchy(list) {
    const hierarchy = [];

    // Iterate through the list
    list.forEach(item => {
        // Find the site object in hierarchy
        let siteNode = hierarchy.find(node => node.name === item.site);

        // If siteNode doesn't exist, create it and add to hierarchy
        if (!siteNode) {
            siteNode = {
                name: item.site,
                children: []
            };
            hierarchy.push(siteNode);
        }

        // Find the division object in siteNode's children
        let divisionNode = siteNode.children.find(node => node.name === item.division);

        // If divisionNode doesn't exist, create it and add to siteNode's children
        if (!divisionNode) {
            divisionNode = {
                name: item.division,
                children: []
            };
            siteNode.children.push(divisionNode);
        }

        // Find the manager object in siteNode's children
        let managerNode = divisionNode.children.find(node => node.name === item.manager);

        // If managerNode doesn't exist, create it and add to siteNode's children
        if (!managerNode) {
            managerNode = {
                name: item.manager,
                children: []
            };
            divisionNode.children.push(managerNode);
        }

        // Find the supervisor object in siteNode's children
        let supervisorNode = managerNode.children.find(node => node.name === item.supervisor);

        // If supervisorNode doesn't exist, create it and add to siteNode's children
        if (!supervisorNode) {
            supervisorNode = {
                name: item.supervisor,
                children: []
            };
            managerNode.children.push(supervisorNode);
        }

        // Find the agent object in siteNode's children
        let agentNode = supervisorNode.children.find(node => node.name === item.agent);

        // If agentNode doesn't exist, create it and add to siteNode's children
        if (!agentNode) {
            agentNode = {
                name: item.agent,
                children: []
            };
            supervisorNode.children.push(agentNode);
        }

        // Add supervisor to divisionNode's children
        agentNode.children.push({
            name: item.name,
            children: undefined // No children for supervisors
        });
    });

    return hierarchy;
}

export function pageLoaded(title) {
    if (document) {
        if (title && typeof title === 'string') {
            title = `${title} | ${DEFAULT_TITLE}`;
        } else {
            title = DEFAULT_TITLE;
        }
        announcePageLoaded(title);
        document.title = title;
    }
}
export function getOnlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export function getXaxisCategories(dd) {
    const c = dd.map((d) => d.dataPoints);
    let e = c.flatMap((x) => x).map((f) => f ? f.label : undefined);
    //e = new Set(e);
    let uniqueArray = e.filter((item, index) => {
        return e && e.indexOf(item) === index;
    });
    return uniqueArray;
};

export function getColorById(id) {
    if (id == -1) {
        return '#1C448E';
    }
    const colors = [
        '#801A86',
        '#B0228C',
        '#7B61FF',
        '#E56B70',
        '#C1292E',
        '#D741A7',
        '#8FE388',
        '#5398BE',
        '#29CC6A',
        '#EB9FEF',
        '#FFD8BE',
        '#8FF7A7',
        '#51BBFE',
        '#FF934F',
        '#77B6EA',
        '#4A7856',
        '#453750',
        '#54C6EB',
        '#048A81',
        '#4F5D75',
        '#D95D39',
        '#545677',
        '#03254E',
        '#06BCC1',
        '#A7ADC6',
        '#56667A',
        '#136F63',
        '#3F88C5',
        '#032B43',
        '#007FFF',
        '#590925',
        '#492C1D',
        '#0496FF',
        '#7D70BA',
        '#5C6D70',
    ];

    return colors[id % (colors.length - 1)];
}

export function getDate(daysFromToday) {
    let today = new Date();
    today.setDate(today.getDate() + daysFromToday);
    let yesterdayYear = today.getFullYear();
    let yesterdayMonth = today.getMonth() + 1;
    let yesterdayDay = today.getDate();

    let yesterdayDate = (yesterdayMonth < 10 ? '0' : '') + yesterdayMonth +
        '-' + (yesterdayDay < 10 ? '0' : '') + yesterdayDay +
        '-' + yesterdayYear;
    return yesterdayDate;
}

export function getRandomItem(array) {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
}

export function getUtcTime(time) {
    if (!isDefined(time))
        return;
    const res = moment(new Date(time)).utc().format(dateTimeFormat)
    return res;
}

export function getSelectedIndividualNode(domainValues, selectedFilterObj, onClick) {
    if (!isDefined(selectedFilterObj))
        return;

    const result = domainValues.find(item => item.domainValues.find(value => value.domainValueId === selectedFilterObj.id));
    const filterType = isDefined(result) ? result.domainName : '';
    let valueAndCloseIcon;
    //To Do: the multiple 
    if (Array.isArray(selectedFilterObj)) {
        valueAndCloseIcon = selectedFilterObj.map((s, index) => {
            if (index < 6) {
                return (<div className="flex-container" key={index}>
                    <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{s.value}</p>
                    <HighlightOffIcon onClick={() => onClick(s.id)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
                </div>);
            } else if (index === 6) {
                return (<div className="flex-container" key={index}>
                    <p className="H3_14 grey-text" style={{ margin: '0 8px 0 8px' }} >more...</p>
                </div>);
            }
        }
        );
    }
    else {
        valueAndCloseIcon = (<>
            <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{selectedFilterObj.value}</p>
            <HighlightOffIcon onClick={() => onClick(selectedFilterObj.id)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
        </>);
    }
    return (
        <div className="selected-node" key={selectedFilterObj.id}>
            <p className="H3_14 orange-text" style={{ margin: '0 8px 0 8px' }} > {filterType}</p> <FilterArrow />
            {valueAndCloseIcon}
        </div>);
}

export function getSelectedNode(filterType, selectedValue, onClick) {
    if (!selectedValue)
        return undefined;
    let valueAndCloseIcon;
    if (Array.isArray(selectedValue)) {
        valueAndCloseIcon = selectedValue.map((s, index) => {
            if (index < 6) {
                return (<div className="flex-container" key={index}>
                    <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{s.value}</p>
                    <HighlightOffIcon onClick={() => onClick(s.id)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
                </div>);
            } else if (index === 6) {
                return (<div className="flex-container" key={index}>
                    <p className="H3_14 grey-text" style={{ margin: '0 8px 0 8px' }} >more...</p>
                </div>);
            }
        }
        );
    }
    else {
        valueAndCloseIcon = (<>
            <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{selectedValue.value}</p>
            <HighlightOffIcon onClick={() => onClick(selectedValue.teamId)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
        </>);
    }
    return (
        <div className="selected-node" key={selectedValue.teamId}>
            <p className="H3_14 orange-text" style={{ margin: '0 8px 0 8px' }} > {filterType}</p> <FilterArrow />
            {valueAndCloseIcon}
        </div>);
}

export function getScoreOnSurveyQuestion(surveyQuestionResponseBreakdown) {
    if (!arrayIsNotEmpty(surveyQuestionResponseBreakdown)) {
        return 0;
    }

    const totalCount = surveyQuestionResponseBreakdown.map(rb => rb.responseCount).reduce((a, b) => a + b, 0);
    if (totalCount === 0) {
        return 0;
    }
    const surveyQuestionName = surveyQuestionResponseBreakdown[0].surveyQuestionName;

    if (surveyQuestionName === "tNPS" || surveyQuestionName === "NPS") {
        const totalSatisfiedCount = surveyQuestionResponseBreakdown.filter(srb => srb.performanceResponseTypeId === 1).map(rb => rb.responseCount).reduce((a, b) => a + b, 0);
        const totalDissatisfiedCount = surveyQuestionResponseBreakdown.filter(srb => srb.performanceResponseTypeId === 3 || srb.performanceResponseTypeId === 4).map(rb => rb.responseCount).reduce((a, b) => a + b, 0);
        return Math.round((100 * (totalSatisfiedCount - totalDissatisfiedCount)) / totalCount);
    } else {
        const totalSatisfiedCount = surveyQuestionResponseBreakdown.filter(srb => srb.performanceResponseTypeId === 1).map(rb => rb.responseCount).reduce((a, b) => a + b, 0);
        return Math.round((100 * totalSatisfiedCount) / totalCount);
    }
}

export function getPieChartColorSetByPerformanceIdAndValue(responsesToQuestion1DataPoints) {
    if (!arrayIsNotEmpty(responsesToQuestion1DataPoints)) {
        return;
    }
    let result = responsesToQuestion1DataPoints.map(res => {
        if (res.responseCount > 0) {
            if (res.performanceResponseTypeId === 1) {
                return '#49CB85';
            }
            else if (res.performanceResponseTypeId === 2) {
                return '#D1DDE1';
            }
            else if (res.performanceResponseTypeId === 3 || res.performanceResponseTypeId === 4) {
                return '#F93B74';
            }
        }
    });

    result = result.filter(r => r !== undefined);
    return result.length > 0 ? result : undefined;
}

export function getTeamDashboardBreakdownOptionsForClient(clientId) {
    if (clientId === clientIdNumber.Rockstar) {
        return [
            { value: "Overall" },
            { value: "Agent" },
            { value: "RFC" },
            { value: "Channel" },
            { value: "Language" },
            { value: "Game" },
        ];
    }
    else if (clientId === clientIdNumber.Comcast) {
        return [
            { value: "Overall" },
            { value: "Agent" },
            { value: "RFC" },
        ];
    }
    else if (clientId === clientIdNumber.Facebook) {
        return [
            { value: "Overall" },
            { value: "Agent" },
            { value: "RFC" },
            { value: "Channel" },
            { value: "Language" },
            { value: "Product" },
        ];
    }
    else {
        return [
            { value: "Overall" },
            { value: "Agent" },
            { value: "RFC" },
            { value: "Channel" }
        ]
    }
}

export function clientHasExtraBreakdown(clientId, breakdown) {
    const breakdowns = getTeamDashboardBreakdownOptionsForClient(clientId);
    const lowercaseInput = breakdown.toLowerCase();
    return breakdowns.some(item => item.value.toLowerCase() === lowercaseInput);
}

export function getPieChartColorSet(responsesToQuestion1DataPoints) {
    if (!arrayIsNotEmpty(responsesToQuestion1DataPoints)) {
        return;
    }
    let result = responsesToQuestion1DataPoints.map(res => {
        if (res.label === 'Very Dissatisfied' || res.label === '1 - Very Dissatisfied') {
            return '#EB074B';
        }
        else if (res.label === 'Dissatisfied' || res.label === '2 - Somewhat Dissatisfied' || res.label === 'No'
            || res.label === 'No - Inquiry Unresolved' || res.label === 'Detractor') {
            return '#F93B74';
        }
        else if (res.label === 'Neutral' || res.label === '3 - Neutral' || res.label === 'Yes-Dissatisfied'
            || res.label === 'Yes - Outcome Not Satisfied' || res.label === 'Passive') {
            return '#D1DDE1';
        }
        else if (res.label === 'Satisfied' || res.label === '4 - Somewhat Satisfied' || res.label === 'Yes'
            || res.label === 'Yes-Satisfied' || res.label === 'Promoter') {
            return '#49CB85'; //colors.correctGreenPrimary;
        }
        else if (res.label === 'Very Satisfied' || res.label === '5 - Very Satisfied') {
            return '#00B252';
        }

        if (res.label === '0' || res.label === '1' || res.label === '2' || res.label === '3' ||
            res.label === '4' || res.label === '5' || res.label === '6') {
            return '#F93B74';
        }
        if (res.label === '7' || res.label === '8') {
            return '#D1DDE1';
        }
        if (res.label === '9' || res.label === '10') {
            return '#49CB85';
        }

        //if (res.label === 'MLB Mobile App') {
        //    return colors.fourth200;
        //}
        //if (res.label === 'Samsung') {
        //    return colors.primary200;
        //}
        //if (res.label === 'Media Player') {
        //    return colors.secandary200;
        //}
        //if (res.label === 'Roku') {
        //    return colors.neutralYellowPrimary;
        //}
        ////if (res.label === '9') {
        ////    return '#00A300';
        ////}
        ////if (res.label === '10') {
        ////    return '#007500';
        ////}
        //else
        //    return '#' + (Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
    });

    result = result.filter(r => r !== undefined);
    return result.length > 0 ? result : undefined;
}

export function formatDate(date) {
    const dateUTC = moment(date).utc();
    const formattedDate = `${moment(dateUTC).format('YYYY')}-${moment(dateUTC).format('MM')}-${moment(dateUTC).format('DD')}`;
    return formattedDate;
}

export function formatDateTime(date) {
    const formattedDate = `${moment(date).format('YYYY')}-${moment(date).format('MM')}-${moment(date).format('DD')}
    -${moment(date).format('hh')}-${moment(date).format('mm')}-${moment(date).format('ss')}`;
    return formattedDate;
}

export function isJibedOnAllQuestions(agentJibedData, calibratedOnSurveyQuestions) {
    if (!isDefined(calibratedOnSurveyQuestions)) {
        return false;
    }
    if (calibratedOnSurveyQuestions.some(item => item.questionCode === 'ASAT') &&
        agentJibedData.representativeSatisfactionCalibrationStatusId !== CalibrationStatus.Jibed) {
        return false;
    }
    else if (calibratedOnSurveyQuestions.some(item => item.questionCode === 'RES') &&
        agentJibedData.resolutionCalibrationStatusId !== CalibrationStatus.Jibed) {
        return false;
    }
    else if (calibratedOnSurveyQuestions.some(item => item.questionCode === 'CSAT') &&
        agentJibedData.customerSatisfactionCalibrationStatusId !== CalibrationStatus.Jibed) {
        return false;
    }
    else if (calibratedOnSurveyQuestions.some(item => item.questionCode === 'NPS') &&
        agentJibedData.netPromoterScoreCalibrationStatusId !== CalibrationStatus.Jibed) {
        return false;
    }
    return true
}

export function isDefined(obj) {
    return ((typeof obj !== 'undefined') && (obj !== null));
}
export function getQuestionColor(questionCode) {
    switch (questionCode) {
        case 'ASAT':
            return colors.fourth200;
        case 'RES':
            return colors.secandary200;
        case 'CSAT':
            return colors.primary200;
        case 'NPS':
            return '#FF9538';
        default:
    }
}

export function arrayIsNotEmpty(obj) {
    return (isDefined(obj) && Array.isArray(obj) && obj.length > 0);
}

export function convertSecondsToTimeFormat(time) {
    let hours = Math.floor(time / 3600);
    time = time - hours * 3600;

    let minutes = Math.floor(time / 60);
    let seconds = (time - minutes * 60);

    hours = `${hours}`.padStart(2, '0');
    minutes = `${minutes}`.padStart(2, '0');
    seconds = `${seconds}`.padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
}

export function getPercentage(partialValue, totalValue) {
    if (totalValue === 0) {
        return;
    }
    return Math.round((partialValue / totalValue) * 100)
}

export function getPercentageChange(v1, v2) {
    if (v1 === 0) {
        return;
    }
    const change = Math.round(((v2 - v1) * 100) / v1);
    return change;
}

export function cloneArray(arr) {
    if (!isDefined(arr))
        return;
    const clonedArr = arr.map(t => { return { ...t } });
    return clonedArr;
}

export function sortReactTable(a, b, desc) {
    a = a === null || a === undefined ? -Infinity : a;
    b = b === null || b === undefined ? -Infinity : b;
    let aValue = typeof a === 'string' || a instanceof String || typeof a === 'number' || a === -Infinity ? a : a.props.children;
    let bValue = typeof b === 'string' || b instanceof String || typeof b === 'number' || b === -Infinity ? b : b.props.children;
    // force null and undefined to the bottom
    aValue = aValue === null || aValue === undefined ? -Infinity : aValue;
    bValue = bValue === null || bValue === undefined ? -Infinity : bValue;
    // force any string values to lowercase
    aValue = aValue === 'string' ? aValue.toLowerCase() : aValue;
    bValue = bValue === 'string' ? bValue.toLowerCase() : bValue;

    aValue = isNumeric(aValue) ? parseFloat(aValue) : aValue;
    bValue = isNumeric(bValue) ? parseFloat(bValue) : bValue;
    // Return either 1 or -1 to indicate a sort priority
    if (aValue > bValue) {
        return 1;
    }
    if (aValue < bValue) {
        return -1;
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0;
}

function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export function updateUrlParams(paramURL) {
    history.push(paramURL)
}

export function getLocalTimeOffsetInHour() {
    const offsetInHour = new Date().getTimezoneOffset() / 60;
    return offsetInHour;
}

export function getTimeDiff(startTime, endTime, inputTimeFortam, outputTimeFortam) {
    let diff = moment(endTime, inputTimeFortam).diff(moment(startTime, inputTimeFortam));
    let totalDuration = moment.duration(diff);
    let durationFormatted = Math.floor(totalDuration.asHours()) + moment.utc(diff).format(outputTimeFortam);
    return durationFormatted;
}

export function getIsCalibratedOnSurveyQuestions(agentSurveyForm) {
    const isCalibratedOnSurveyQuestions = agentSurveyForm.SurveyQuestions.filter(sq => sq.IsCalibratedOn && sq.IsOnAgentSurvey);
    return isCalibratedOnSurveyQuestions;
}

export function getInitialDateRange(client) {
    if (!client) return undefined;

    const endDateSetting = client.GetSetting(ClientSettingKeys.DefaultTimeSpanEndDate);
    const startDateSetting = client.GetSetting(ClientSettingKeys.DefaultTimeSpanStartDate);
    const timeSpanLengthInDays = client.GetSetting(ClientSettingKeys.DefaultTimeSpanLengthInDays);

    const endDate = endDateSetting ? moment(endDateSetting).format('M/D/YYYY') : moment().format('M/D/YYYY');
    const result = {
        startDate: startDateSetting
            ? moment(startDateSetting).format('M/D/YYYY')
            : !timeSpanLengthInDays
                ? moment()
                    .startOf('month')
                    .format('M/D/YYYY')
                : moment(endDate)
                    .subtract(timeSpanLengthInDays, 'd')
                    .format('M/D/YYYY'),
        endDate
    };

    return result;
}

export function getMedia(fileId) {
    const path = `/api/file?Id=${fileId}`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function addUpdateQueryStringParameters(newParameters) {
    const location = Object.assign({}, history.getCurrentLocation());
    Object.assign(location.query, newParameters);
    history.push(location);
}

export function getProfilePictureNode(user, fileType, style, size) {
    const profilePicture = user.ImageFileSet ? user.ImageFileSet.Files.find(f => f.FileTypeId === fileType) : undefined;
    const profilePictureUrl = !profilePicture ? undefined : '/Download.ashx?fileId=' + profilePicture.Id;
    const avatarSize = size ? size : 60;
    const avatarStyle = style ? style : { marginRight: '5px' };

    return (
        <Avatar
            key={user.Id}
            colors={['red', 'deepskyblue', 'forestgreen', 'darkorchid', 'blueviolet', 'cornflowerblue']}
            style={avatarStyle}
            size={avatarSize}
            round={true}
            textSizeRatio={1.5}
            name={user.Name || user.UserName}
            title={user.Name || user.UserName}
            src={profilePictureUrl}
        />
    );
}

export function guid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
}

export function ifNull(a, b) {
    if (a === null) return b ? b : '';
    return a;
}

export function sortBy(array, valueGetter, isNumeric, direction) {
    if (isNumeric) {
        if (direction && direction === OrderByDirection.Desc) array.sort((a, b) => valueGetter(b) - valueGetter(a));
        else array.sort((a, b) => valueGetter(a) - valueGetter(b));
    } else {
        if (direction && direction === OrderByDirection.Desc)
            array.sort((a, b) => (valueGetter(b) || '').localeCompare(valueGetter(a) || ''));
        else array.sort((a, b) => (valueGetter(a) || '').localeCompare(valueGetter(b) || ''));
    }
}

export function sortByMultiple(array, sortDescriptors) {
    array.sort((a, b) => {
        for (let i = 0; i < sortDescriptors.length; i++) {
            const { valueGetter, isNumeric, direction } = sortDescriptors[i];
            let sortValue;
            if (isNumeric) {
                if (direction && direction === OrderByDirection.Desc) sortValue = valueGetter(b) - valueGetter(a);
                else sortValue = valueGetter(a) - valueGetter(b);
            } else {
                if (direction && direction === OrderByDirection.Desc)
                    sortValue = (valueGetter(b) || '').localeCompare(valueGetter(a) || '');
                else sortValue = (valueGetter(a) || '').localeCompare(valueGetter(b) || '');
            }
            if (sortValue !== 0) return sortValue;
        }
        return 0;
    });
}

export function getDuration(start, end, missMessage) {
    return start && end
        ? moment.duration(moment(end) - moment(start)).format('h:mm:ss', { trim: false })
        : missMessage
            ? missMessage
            : '--';
}

export function getDurationFromSeconds(seconds) {
    return seconds ? moment.duration(seconds, 'seconds').format('h:mm:ss', { trim: false }) : '--';
}

export function getRandom(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}

export function ensureArray(value) {
    return value ? (Array.isArray(value) ? value : [value]) : [];
}

export function arraysEqual(arrayA, arrayB, predicate) {
    if (arrayA.length !== arrayB.length) return false;
    if (!arrayA.length) return true;

    for (let i = 0; i < arrayA.length; i++) {
        const itemA = arrayA[i];
        let found;
        for (let j = 0; j < arrayB.length; j++) {
            found = predicate(itemA, arrayB[j]);
            if (found) break;
        }
        if (!found) return false;
    }
    return true;
}

export function dedupeArray(arr) {
    return arr.filter((value, index, self) => self.indexOf(value) === index);
}

export function mergeAndDedupeArray(...arr) {
    return [...new Set([].concat(...arr))];
}

export function distinctArray(array, keySelector) {
    let objectTree = {};
    array.forEach(o => {
        objectTree[keySelector(o)] = o;
    });
    return Object.keys(objectTree).map(o => {
        return objectTree[o];
    });
}

function getNewGroup(idKey, id, displayText, parentGroupings, fieldDescriptor) {
    const newGroup = [];
    newGroup.groupedBy = [...parentGroupings, { key: idKey, value: id, displayText, fieldDescriptor }];
    return newGroup;
}

export function groupBy(array, fieldDescriptors) {
    if (!array || !fieldDescriptors || !fieldDescriptors.length) {
        const nonGroupReturn = array || [];
        nonGroupReturn.groupedBy = [];
        return nonGroupReturn;
    }

    const fieldDescriptor = fieldDescriptors.shift();
    const { idKey, displayKey } = fieldDescriptor;
    const parentGroupings = array.groupedBy || [];
    const results = array.reduce(function (groups, item) {
        let id = item[idKey] || 0;
        groups[id] = groups[id] || getNewGroup(idKey, id, item[displayKey] || '--', parentGroupings, fieldDescriptor);
        groups[id].push(item);
        return groups;
    }, []);
    results.groupedBy = parentGroupings;
    if (fieldDescriptors.length > 0)
        results.forEach((item, index) => {
            results[index] = groupBy(item, fieldDescriptors.slice());
        });
    return results;
}

export function groupByField(list, keyGetter) {
    const map = new Map();
    list.forEach(item => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

export function checkSetting(client, settingKey) {
    if (!client) return false;
    if (!settingKey) return true;
    const setting = client.GetSetting(settingKey);
    return setting !== 'false';
}

export function checkPrivledges(user, authorizedRoles, isZacousticOnly) {
    if (!user) {
        const currentState = window.localStorage.session ? JSON.parse(window.localStorage.session) : store.getState();;
        const permissionArray = currentState.permissions ? currentState.permissions.split(',') : undefined;
        const doesUserHavePermission = permissionArray && authorizedRoles ? permissionArray.some(item => authorizedRoles.includes(parseInt(item))) : false;

        if (doesUserHavePermission) {
            return true;
        }
        else {
            return false;
        }
    }
    if (isZacousticOnly)
        return (
            user &&
            (user.ClientId === 1 && user.Permissions.find(o => o.Id === ZacousticPermission.AdminCreateEditUsers))
        );
    if (!authorizedRoles || authorizedRoles.length === 0) return true;
    return (
        user &&
        ((user.ClientId === 1 && user.Permissions.find(o => o.Id === ZacousticPermission.AdminCreateEditUsers)) ||
            user.Permissions.find(o => authorizedRoles.find(p => p === o.Id)))
    );
}

export function isoOffset(offsetMinutes) {
    const plusMinus = offsetMinutes >= 0 ? '+' : '-';
    let hours = '00';
    let minutes = '00';
    const absMinutes = Math.abs(offsetMinutes);

    if (absMinutes > 0) {
        let h = Math.floor(absMinutes / 60);
        if (h > 0) {
            hours = h >= 10 ? `${h}` : `0${h}`;
        }
        let m = Math.floor(absMinutes % 60);
        minutes = m >= 10 ? `${m}` : `0${m}`;
    }
    return `${plusMinus}${hours}:${minutes}`;
}

export function getDuplicates(array) {
    const valuesSoFar = Object.create(null);
    for (let i = 0; i < array.length; ++i) {
        const value = array[i];
        if (value in valuesSoFar) {
            return value;
        }
        valuesSoFar[value] = true;
    }
    return null;
}

export function isAudioFile(fileName) {
    const allowedAudioExtensions = /(\.MP3|\.WAV|\.PCM|\.AIFF|\.PCM|\.AAC|\.OGG|\.WMA|\.FLAC|\.ALAC|\.M4A)$/i;
    return allowedAudioExtensions.exec(fileName);
}

export function downloadFile(path) {
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(response => {
        if (!response.ok) return Promise.reject(response);

        const contentType = response.headers.get('Content-Type');
        const contentDisposition = response.headers.get('Content-Disposition');
        response.blob().then(blob => {
            let fileName = contentDisposition.substr(contentDisposition.lastIndexOf('=') + 2);
            fileName = fileName.substr(0, fileName.length - 1);
            download(blob, fileName, contentType);
            return Promise.resolve(response);
        });
    });
}

export function applySurveyQuestionViews(viewKey, surveyForm, user) {
    const surveyQuestionViews = surveyForm.SurveyQuestionViews.filter(o => o.ViewKey === viewKey).map(o => {
        const obj = Object.assign({}, o);
        Object.keys(obj).forEach(key => !obj[key] && delete obj[key]);
        return obj;
    });
    const userSurveyQuestionViews = user.SurveyQuestionViews.filter(o => o.ViewKey === viewKey).map(o => {
        const obj = Object.assign({}, o);
        Object.keys(obj).forEach(key => !obj[key] && delete obj[key]);
        return obj;
    });

    let effectiveSurveyQuestionViews = [];
    userSurveyQuestionViews.forEach(userElementView => {
        const surveyQuestionView = surveyQuestionViews.find(
            o => o.SurveyQuestionId === userElementView.SurveyQuestionId
        );
        if (surveyQuestionView) {
            effectiveSurveyQuestionViews.push(Object.assign(surveyQuestionView, userElementView));
        } else {
            effectiveSurveyQuestionViews.push(userElementView);
        }
    });
    surveyQuestionViews.forEach(surveyQuestionView => {
        const userElementView = userSurveyQuestionViews.find(
            o => o.SurveyQuestionId === surveyQuestionView.SurveyQuestionId
        );
        if (!userElementView) {
            effectiveSurveyQuestionViews.push(surveyQuestionView);
        }
    });

    surveyForm.SurveyQuestions.forEach(element => {
        const view = effectiveSurveyQuestionViews.find(o => o.SurveyQuestionId === element.Id);
        element[viewKey] = {
            Ordinal: view ? (view.Ordinal ? view.Ordinal : element.Ordinal) : element.Ordinal,
            IsHidden: view ? (view.IsHidden ? view.IsHidden : false) : false
        };
    });
}

export function getUpdatedQueryStringParameters(queryStringParameter, parametersToAddUpdate, parametersToRemove) {
    parametersToRemove.forEach(function (key) {
        if (queryStringParameter[key] || queryStringParameter[key] === 0) {
            queryStringParameter[key] = undefined;
        }
    });

    //assign
    let updatedQueryStringParameter = queryStringParameter;
    Object.keys(parametersToAddUpdate).forEach(function (key) {
        updatedQueryStringParameter[key] = parametersToAddUpdate[key];
    });
    return updatedQueryStringParameter;
}

export function pushQueryStringToUrl(queryStringParameter) {
    let urlQueryString = '?';
    Object.keys(queryStringParameter).forEach(function (key) {
        if (key && key !== '') {
            if (queryStringParameter[key] || queryStringParameter[key] === 0) {
                if (urlQueryString !== '?') urlQueryString += '&';
                if (Array.isArray(queryStringParameter[key])) {
                    queryStringParameter[key].forEach(function (element) {
                        if (urlQueryString !== '?') urlQueryString += '&';
                        urlQueryString += `${key}=${element}`;
                    });
                } else {
                    urlQueryString += `${key}=${queryStringParameter[key]}`;
                }
            }
        }
    });
    history.push(`${window.location.pathname}${urlQueryString}`);
}

export function updateUrl(currentQueryStringParameter, parametersToAddUpdate, parametersToRemove) {
    const updatedQueryStringParameters = getUpdatedQueryStringParameters(
        currentQueryStringParameter,
        parametersToAddUpdate,
        parametersToRemove
    );
    pushQueryStringToUrl(updatedQueryStringParameters);
}

export function getInitialSurveyFormBasedOnTemplate(value, surveyFormToCreateName) {
    if (!value) return undefined;

    value.Id = 0;
    value.Name = surveyFormToCreateName;
    value.SurveyQuestions = value.SurveyQuestions.filter(q => q.DisplayText && q.IsEnabled && !q.IsDeleted);
    for (var i = 0, qlen = value.SurveyQuestions.length; i < qlen; i++) {
        const surveyQuestionGuidId = guid();
        value.SurveyQuestions[i].Id = 0;
        value.SurveyQuestions[i].UniqueId = surveyQuestionGuidId;
        value.SurveyQuestions[i].SurveyFormId = 0;
        value.SurveyQuestions[i].Values = value.SurveyQuestions[i].Values.filter(
            v => v.Value && v.IsEnabled && !v.IsDeleted
        );
        for (var j = 0, rlen = value.SurveyQuestions[i].Values.length; j < rlen; j++) {
            value.SurveyQuestions[i].Values[j].Id = 0;
            value.SurveyQuestions[i].Values[j].SurveyQuestionId = 0;
            value.SurveyQuestions[i].Values[j].PointValue = 0;
        }
    }

    return value;
}

export const CalibratorSelectMode = {
    Search: 1,
    Assignments: 2,
    Both: 3
};

export const CalibratorMode = {
    calibrator: {
        label: 'Calibrator',
        showResponses: true,
        calibratorSelectMode: CalibratorSelectMode.Both,
        compareParentSurveyType: SurveyType.Calibrator,
        compareChildSurveyType: SurveyType.Agent,
        respondSelectFromSurveyType: SurveyType.Agent,
        respondWithSurveyType: SurveyType.Calibrator,
        respondAssignSurveyType: SurveyType.Calibrator,
        selectFromPermissionIds: [ZacousticPermission.CalibratorCalibrateSurveys],
        assignToPermissionIds: [ZacousticPermission.CalibratorCalibrateSurveys]
    },
    audit: {
        label: 'Internal Calibration',
        showResponses: false,
        calibratorSelectMode: CalibratorSelectMode.Assignments,
        compareParentSurveyType: SurveyType.MasterCalibrator,
        compareChildSurveyType: SurveyType.MasterCalibratorResponse,
        respondSelectFromSurveyType: SurveyType.MasterCalibrator,
        respondWithSurveyType: SurveyType.MasterCalibratorResponse,
        selectFromPermissionIds: [],
        assignToPermissionIds: []
    },
    master: {
        label: 'Master Calibration',
        showResponses: true,
        respondWithSurveyAssignment: true,
        calibratorSelectMode: CalibratorSelectMode.Search,
        compareParentSurveyType: SurveyType.MasterCalibrator,
        compareChildSurveyType: SurveyType.MasterCalibratorResponse,
        respondSelectFromSurveyType: SurveyType.Agent,
        respondWithSurveyType: SurveyType.MasterCalibrator,
        respondAssignSurveyType: SurveyType.MasterCalibratorResponse,
        selectFromPermissionIds: [ZacousticPermission.CalibratorAssignSurveys],
        assignToPermissionIds: [ZacousticPermission.CalibratorAssignSurveys]
    },
    supervisor: {
        label: 'Supervisor',
        showResponses: true,
        showDirectReportsOnly: true,
        calibratorSelectMode: CalibratorSelectMode.Search,
        compareParentSurveyType: SurveyType.Calibrator,
        compareChildSurveyType: SurveyType.Agent,
        respondSelectFromSurveyType: SurveyType.Agent,
        respondWithSurveyType: SurveyType.Calibrator, // TODO: Should supervisors ever respond?
        respondAssignSurveyType: SurveyType.Calibrator,
        selectFromPermissionIds: [ZacousticPermission.CalibratorCalibrateSurveys],
        assignToPermissionIds: [ZacousticPermission.CalibratorCalibrateSurveys]
    },
    proxy: {
        label: 'Proxy',
        showResponses: true,
        compareParentSurveyType: SurveyType.Proxy,
        compareChildSurveyType: SurveyType.Calibrator,
        respondSelectFromSurveyType: SurveyType.Calibrator,
        respondWithSurveyType: SurveyType.Proxy,
        selectFromPermissionIds: [ZacousticPermission.CalibratorCalibrateSurveys],
        assignToPermissionIds: [ZacousticPermission.CalibratorCalibrateSurveys]
    },
    qa: {
        label: 'QA',
        showResponses: true,
        compareParentSurveyType: SurveyType.QA,
        compareChildSurveyType: SurveyType.Agent,
        respondSelectFromSurveyType: SurveyType.Agent,
        respondWithSurveyType: SurveyType.QA,
        selectFromPermissionIds: [ZacousticPermission.CalibratorCalibrateSurveys],
        assignToPermissionIds: [ZacousticPermission.CalibratorCalibrateSurveys]
    }
};
